import { useFormContext } from 'react-hook-form';

import { EditHeader } from './components/EditHeader';
import {
  AnswersObject,
  EditPaneProps,
} from 'features/Connect/features/ConnectATSIntegration/types/scorecardTypes';
import { ScorecardQuestionAndAnswerSection } from '../Create/components/ScorecardQuestionAndAnswerSection';
import { QuestionContainer } from '../../../styles/scorecardStyles';
import { CandidateFeedbackModalTypes } from 'features/Connect/features/ConnectATSIntegration/enums';

export const EditPane: React.FC<EditPaneProps> = ({
  candidateName,
  created,
  isReadOnly,
  modalType,
  reviewer,
  templateName,
}) => {
  const titleText =
    modalType === CandidateFeedbackModalTypes.SCORECARD
      ? `Scorecard for ${candidateName}`
      : `Reference check for ${candidateName}`;

  const { watch } = useFormContext();
  const answers = watch('answers');

  return (
    <form>
      <EditHeader
        created={created}
        reviewer={reviewer}
        templateName={templateName}
        titleText={titleText}
      />
      {answers.map((answer, index) => {
        const abbreviatedAnswers: AnswersObject = {
          attachment: answer?.attachment,
          multipleChoice: answer?.mc_answer,
          rating: answer?.answer_rating,
          rubric: answer?.answer_rubric,
          text: answer?.answer_text,
        };
        return (
          <QuestionContainer key={answer.question_id}>
            <ScorecardQuestionAndAnswerSection
              answers={abbreviatedAnswers}
              index={index}
              question={answer.question}
              isReadOnly={isReadOnly}
            />
          </QuestionContainer>
        );
      })}
    </form>
  );
};
